// 다시 보내기 상태 — 컴포넌트가 아닌 값·훅은 여기에 둔다(signup-sent.tsx 의 Fast Refresh 가 깨지지 않게).

import { useEffect, useState } from "react";

import { SIGNUP_RESEND_COOLDOWN_SECONDS } from "@buildpy/core/modules/onboarding/rules";

export const RESEND_COOLDOWN_SECONDS = SIGNUP_RESEND_COOLDOWN_SECONDS;
export const RESEND_FAILED_MESSAGE = "다시 보내지 못했습니다. 잠시 후 다시 시도하세요.";

// 「다시 보내기 · 42초 뒤」 · 기다림이 끝나면 「다시 보내기」.
export const resendLabelOf = (left: number): string => (left > 0 ? `다시 보내기 · ${left}초 뒤` : "다시 보내기");

// 다시 보내기 대기 초 — 1초씩 줄고 restart 로 처음부터 다시 센다(비밀번호 찾기 화면도 같은 한 벌).
export const useResendCooldown = (initial: number = RESEND_COOLDOWN_SECONDS) => {
  const [left, setLeft] = useState(initial);
  useEffect(() => {
    if (left <= 0) return;
    const timer = window.setTimeout(() => setLeft((n) => Math.max(0, n - 1)), 1000);
    return () => window.clearTimeout(timer);
  }, [left]);
  return { left, restart: () => setLeft(RESEND_COOLDOWN_SECONDS) };
};
